import { useContext, useEffect, useState } from "react";
import { Basket } from "../../types/Basket/Basket";
import useBasketService from "../../hooks/useBasketService";
import { AuthContext } from "../../components/auth/AuthContext";
import { BasketContext } from "./BasketContext";

interface BasketProviderProps {
  children: React.ReactNode;
}

const BasketProvider = ({ children }: BasketProviderProps) => {
  const [basket, setBasket] = useState<Basket | null>();
  const { user } = useContext(AuthContext)!;
  const basketService = useBasketService();

  useEffect(() => {
    if (user) {
      basketService
        .GetBasket()
        .then((x) => setBasket(x))
        .catch(() => {});
    }
  }, [user]);

  return (
    <BasketContext.Provider value={{ basket, setBasket }}>
      {children}
    </BasketContext.Provider>
  );
};

export default BasketProvider;
